import { useMemo } from 'react';

import {
  ILockInfo,
  LockContext,
  useLock,
} from '@work4all/components/lib/hooks';

interface LockFeatureProps {
  feature: string;
  lockOverride?: boolean;
  children?: React.ReactNode;
}

/**
 * Allow to unlock for certain reason passed by Higher LockOverride.
 */
export function LockFeature({
  feature,
  lockOverride,
  children,
}: LockFeatureProps) {
  const ctx = useLock();

  const { isLockedByFeature, lock, unlock, user, lockReason, lockReasonTitle } =
    ctx;

  const override = useMemo<ILockInfo>(() => {
    const locked = isLockedByFeature(feature) || lockOverride;
    return {
      locked,
      lock,
      unlock,
      user,
      lockReason,
      lockReasonTitle,
      isLockedByFeature,
    };
  }, [
    feature,
    lock,
    unlock,
    user,
    lockReason,
    lockReasonTitle,
    isLockedByFeature,
    lockOverride,
  ]);

  return (
    <LockContext.Provider value={override}>{children}</LockContext.Provider>
  );
}
